var exports = {
  "q": "GuildBoostLevelBadge.module__badge___QkUtX0",
};

module.exports = exports;
